import type { ProcessStep } from '../types'

export const processSteps: ProcessStep[] = [
  {
    number: '1',
    title: 'Llenas el formulario',
    description:
      'Me cuentas sobre tu negocio y qué necesitas. 5 preguntas, menos de 1 minuto.',
  },
  {
    number: '2',
    title: 'Hablamos por WhatsApp',
    description:
      'Te contacto en menos de 24 horas para entender tu visión y arrancar.',
  },
  {
    number: '3',
    title: 'Yo construyo tu web',
    description:
      'Me encargo de diseño, textos y configuración técnica. Tú no haces nada.',
  },
  {
    number: '4',
    title: 'Tu web va en vivo',
    description:
      'En 7 días tu web está publicada, en Google y lista para recibir clientes.',
  },
]
